export class ContactInfo {
    street: string|null = null;
    streetNumber: string|null = null;
    postalCode: number | null = null;
    postalCodeString: string | null = null;
    city: string|null = null;
    phoneNumber: string|null = null;
}